export const API_FORMATION_SECTION_FIELDS_TRANSLATIONS_FIELDS = [
    'project_first_type.formation_section.translations.id',
    'project_first_type.formation_section.translations.title',
    'project_first_type.formation_section.translations.description'
];
